export default __webpack_public_path__ + "static/media/license-illustration.adb995e8.svg";